export enum WatchingMediaProfileMetricProperties {
  ProfileId = 'profileId',
  MediaId = 'mediaId',
  CurrentPosition = 'currentPosition',
  ViewedSections = 'viewedSections',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  SeriesId = 'seriesId',
}
export enum WatchingMediaProfileMetricMetaProperties {}
